import { RankedCompanyApi, RankedCompanyView } from '../types/marketOverview';
import { canonicalizeSizeRange } from './sizeBuckets';

const toFiniteNumber = (value: unknown, fallback = 0): number => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return fallback;
};

export const mapRankedCompany = (company: RankedCompanyApi, index: number): RankedCompanyView => {
  const cleanCompanyName = (company.CleanCompanyName || '').trim() || 'Unknown company';
  const latestYearRaw = company.LatestYear;
  const latestYear =
    latestYearRaw === null || latestYearRaw === undefined || String(latestYearRaw).trim() === ''
      ? 'N/A'
      : String(latestYearRaw);
  const rawGap = toFiniteNumber(company.DiffMeanHourlyPercent, Number.NaN);
  const resolvedSize = canonicalizeSizeRange(company.EmployerSize);

  return {
    id: company.id === null || company.id === undefined ? `${cleanCompanyName}-${index}` : String(company.id),
    cleanCompanyName,
    latestYear,
    finalIndustryCode: company.FinalIndustryCode ?? null,
    employerSize: resolvedSize,
    letterGrade: (company.LetterGrade || 'N/A').trim() || 'N/A',
    finalCompositeScore: toFiniteNumber(company.FinalCompositeScore, 0),
    diffMeanHourlyPercent: Number.isFinite(rawGap) ? rawGap : null,
    companyLinkToGPGInfo: company.CompanyLinkToGPGInfo || null,
    resolvedSize,
  };
};

export const mapRankedCompanies = (companies: RankedCompanyApi[]): RankedCompanyView[] =>
  (Array.isArray(companies) ? companies : []).map(mapRankedCompany);
